import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataWardListService = (
  params: Types.MasterDataWardListRequest
) =>
  RestAPIClient.call<Types.MasterDataWardListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${String(params?.districtId)}`,
    config: {
      requireAuthentication: true,
      params: omit(params, ["districtId"]),
    },
  });

export const masterDataWardListShortService = (
  params: Types.MasterDataWardListRequest
) =>
  RestAPIClient.call<Types.MasterDataWardListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${String(params?.districtId)}/short`,
    config: {
      requireAuthentication: true,
      params: omit(params, ["districtId"]),
    },
  });
